/*eslint-disable*/
import React from "react";
import {
  Flex,
  Link,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";

export default function Footer() {
  const textColor = useColorModeValue("gray.400", "white");
  return (
    
      <Text
        color={textColor}
        textAlign={{
          base: "center",
          xl: "center",
        }}
        mb={{ base: "10px", xl: "0px" }}
      >
        {" "}
        &copy; {1900 + new Date().getYear()}
        <Text as="span" textAlign="center" fontWeight="500" ms="4px">
          Embrill. All Rights Reserved. Made with love by
          <Link
            mx="3px"
            color={textColor}
            href="https://www.simmmple.com?ref=horizon-chakra-free"
            target="_blank"
            fontWeight="700"
          ></Link>
        </Text>
      </Text>
      
  );
}
